/**
 * woEditDiff.js — the lists a work-order Edit may save (IDI-453).
 *
 * The bug (walk v10 B4.3, F-27): Edit always sent techs:[], lineItems:[],
 * materials:[], its own copy of resources (without check-out state) and
 * attachments. A date-only Edit therefore reset a resource check-out and could
 * wipe lines, materials or a file attached since the page loaded; a tech added
 * beside a crew was dropped.
 *
 * editListsForSave turns a draft into the save shape of each list. The page
 * snapshots it when Edit opens and, on Save, sends a list only when its save
 * shape changed. Attachments are never part of it: a file is attached or
 * removed by its own call.
 */

const asList = (v) => (Array.isArray(v) ? v : []);

export function editListsForSave(draft) {
  const d = draft || {};
  const techsIn = asList(d.techs);
  const resolvedT = techsIn.filter((t) => t && t.resolved);
  const unresolvedT = techsIn.filter((t) => t && !t.resolved);
  const resIn = asList(d.resources);
  const resolvedR = resIn.filter((r) => r && r.resolved);
  const unresolvedR = resIn.filter((r) => r && !r.resolved);
  return {
    techs: [
      ...resolvedT.map((t) => ({ id: t.id, name: t.name })),
      ...unresolvedT.map((t) => ({ id: null, name: t.name })),
    ],
    techIds: resolvedT.map((t) => t.id),
    lineItems: asList(d.lineItems),
    materials: asList(d.materials),
    resources: [
      ...resolvedR.map((r) => ({ id: r.id, name: r.name, category: r.category })),
      ...unresolvedR.map((r) => ({ id: null, name: r.name, category: r.category })),
    ],
    resourceIds: resolvedR.map((r) => r.id),
  };
}

/**
 * The list fields of `updates` that changed between the seed (Edit opened)
 * and the draft (Save). techs/techIds and resources/resourceIds travel as
 * pairs; nothing unchanged is ever included.
 */
export function changedEditLists(seedLists, draft) {
  const now = editListsForSave(draft);
  const seed = seedLists || {};
  const changed = (k) => JSON.stringify(now[k]) !== JSON.stringify(seed[k]);
  return {
    ...(changed('techs') ? { techs: now.techs, techIds: now.techIds } : {}),
    ...(changed('lineItems') ? { lineItems: now.lineItems } : {}),
    ...(changed('materials') ? { materials: now.materials } : {}),
    ...(changed('resources') ? { resources: now.resources, resourceIds: now.resourceIds } : {}),
  };
}

export default editListsForSave;
